// src/components/PhoneNumberField.tsx
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Import the default styles
import { styled } from '@mui/material/styles';
import { Controller } from 'react-hook-form';
import { FormHelperText, Box } from '@mui/material';


const CustomPhoneInput = styled(Box)(({ theme }) => ({
  '& .field-title': {
    display: 'block',
    color: '#3F3F44',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '18px',
    position: 'static',
  },
  '& .react-tel-input': {
    marginTop: theme.spacing(1.25),
    '& .form-control': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      backgroundColor: '#F6F6F6',
      borderRadius: 8,
      minHeight: 60,
      paddingLeft: 78,
      boxShadow: 'none',
      color: '#333',
      fontSize: 16,
      borderColor: 'rgba(0, 0, 0, 0.23)',
      transition: '100ms',
      '&:focus': {
        borderColor: '#002f73',
        boxShadow: '0 0 0 1px #002f73',
        '& ~ .flag-dropdown': {
          borderColor: '#002f73',
          boxShadow: '0 0 0 1px #002f73',
        },
      },
    },
    '& .flag-dropdown': {
      borderRadius: '8px 0 0 8px',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      transition: '100ms',
      '& .selected-flag': {
        background: 'transparent',
        transition: '100ms',
        width: 64,
        justifyContent: 'center',
        display: 'flex',
        padding: 0,
        '& .flag': {
          transform: 'scale(1.2)',
        },
      }
    },

    '&:hover': {
      '& .form-control': {
        borderColor: '#333',
      },
      '& .flag-dropdown': {
        borderColor: '#333',
      }
    }
  },
}));

type PhoneNumberFieldProps = {
  name: string;
  control: any; // You can type this further if needed
  label?: string;
  countryCodeName?: string; // Optional prop for country code field name
  setValue?: any; // setValue function from useForm hook
  watch: any; // watch function from useForm hook
};

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({ name, control, label, countryCodeName, setValue, watch }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <CustomPhoneInput>
          {label && <label className="field-title">{label}</label>}
          <PhoneInput
            country={'us'} // Default country (you can change it or make it dynamic)
            value={watch(countryCodeName) + field.value}
            enableSearch
            onChange={(phone: string, country: any) => {
              // Set the full phone number (with country code)
              const rawNumber = phone.replace(country.dialCode, '').replace(/^\+/, '');
              console.log(rawNumber, "rawNumber");
              field.onChange(rawNumber);

              // Set country code in separate field if provided
              if (countryCodeName && setValue) {
                setValue(countryCodeName, `+${country.dialCode}`);
              }
            }}
            inputProps={{
              name,
              required: true,
              autoFocus: false,
            }}
            containerStyle={{ width: '100%' }}
            inputStyle={{ width: '100%' }}
          />
          {fieldState?.error && (<FormHelperText error>{fieldState.error.message}</FormHelperText>
          )}
        </CustomPhoneInput>
      )}
    />
  );
};

export default PhoneNumberField;